<template>
  <ProductPricePage
    :product="data.product"
    :product-data="data.productData"
    :subscription="subscription"
  >
    <NuxtPage
      :product="data.product"
      :product-data="data.productData"
      :subscription="subscription"
    />
  </ProductPricePage>
</template>

<script setup lang="ts">
import {
  CATHODE,
  MARKET,
  SUBSCRIPTION_PRICE_ASSESSMENTS_CATHODE,
} from '~/constants/services/constants'
import cathodeData from '~/constants/price-assessments/unauthorized/cathode'
import ProductPricePage from '~/components/market/ProductPricePage.vue'

/*-------------------------------------
    Meta
-------------------------------------*/
definePageMeta({ layout: 'services' })

const subscription = SUBSCRIPTION_PRICE_ASSESSMENTS_CATHODE
const data = {
  product: CATHODE,
  productData: cathodeData,
  subscription,
}

/*-------------------------------------
    SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${CATHODE.name} Prices`,
})
useHead(seo)
</script>
